export class MetaData {
  updatedProductsDateTime: string | null;

  constructor(updatedProductsDateTime: string | null) {
    this.updatedProductsDateTime = updatedProductsDateTime;
  }
}
